require('./brokerHireAlternativeInvestmentFundHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ContentBox } = require('commonsComponents/contentBox');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');
// @ helpers
const {
  formatAmount,
  formatAmountObject,
  getPlainAmountObject,
  formatPercentage,
} = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
  BROKER_FUNDS_INDEX_VARIATION_DECIMALS,
  BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS,
  BROKER_FUNDS_PARTICIPATIONS_DECIMALS,
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const language = getLanguage();

class BrokerHireAlternativeInvestmentFundHeader extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }

  getParticipacionesLabel(immInvestmentFunds) {
    const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);

    if (isSubscription) {
      const holdingValue = immInvestmentFunds.get('holding');
      const holdingNumber = holdingValue.get('numberOfHoldings');
      const plainAmountObject = getPlainAmountObject(holdingValue);

      return (
        <span className="broker-hire-alternative-investment-header__holding-container-text">
          <FormattedText value={'brokerHireInvestment-holdingNumberLabel'} />
          {formatAmount(holdingNumber, undefined, BROKER_FUNDS_PARTICIPATIONS_DECIMALS)}
          <FormattedText value={'brokerHireInvestment-holdingAmountLabel'} />
          <OneLineSymbolAmount
            amountObject={plainAmountObject}
            language={language}
            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
          />
        </span>
      );
    } else {
      return '';
    }
  }

  render() {
    const { immInvestmentFunds } = this.props;
    const investmentFunds = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds']);
    const name = investmentFunds.get('name');
    const isin = investmentFunds.get('isin');
    const minInvestment = investmentFunds.get('minInvestment');
    const suscription = investmentFunds.get('suscription');
    const injectedSuscription = formatText(`brokerAlternativeFundsBuy-suscription_${suscription}`).toLowerCase();
    const refund = investmentFunds.get('refund');
    const injectedRefund = formatText(`brokerAlternativeFundsBuy-refund_${refund}`).toLowerCase();
    const lockUp = investmentFunds.get('lockUp');
    const rentability = formatPercentage(investmentFunds.get('rentability'), language, 0);
    const plainAmountObject = getPlainAmountObject(minInvestment);

    return (
      <ContentBox
        id="brokerStocksLikeHeader"
        customClassName="broker-hire-alternative-investment-header broker-hire-alternative-investment-header--funds"
      >
        <div className="broker-hire-alternative-investment-header__header row">
          <div className="col-lg-8">
            <div className="broker-hire-alternative-investment-header__company-header">
              <h2 className="broker-hire-alternative-investment-header__company-name">{name}</h2>
            </div>
            <span className="broker-hire-alternative-investment-header__isin">
              <FormattedText value={'brokerAlternativeFundsBuy-isin'} />{isin}
            </span>
          </div>

          <div className="col-lg-4">
            <div className="broker-hire-alternative-investment-header__quote-box">
              <div className="broker-hire-alternative-investment-header__quote">
                <FormattedText value={'brokerAlternativeFundsBuy-minInvestment'} />
                <span className="broker-hire-alternative-investment-header__product-value">
                  <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                  />
                </span>
              </div>

              <div className="broker-hire-alternative-investment-header__quote">
                <FormattedText value={`brokerAlternativeFundsBuy-suscription`} />
                <OKTooltip
                  content={'brokerAlternativeFundsBuy-suscription_tooltipContent'}
                  injectedStrings={[injectedSuscription]}
                  modifier="dark-bg"
                  offset={[-15, 0]}
                  placement="left"
                  type="custom"
                />
                <FormattedText
                  className="broker-hire-alternative-investment-header__product-value"
                  value={`brokerAlternativeFundsBuy-suscription_${suscription}`}
                />
              </div>

              <div className="broker-hire-alternative-investment-header__quote">
                <FormattedText value={`brokerAlternativeFundsBuy-refund`} />
                <OKTooltip
                  content={'brokerAlternativeFundsBuy-refund_tooltipContent'}
                  injectedStrings={[injectedRefund]}
                  modifier="dark-bg"
                  offset={[-15, 0]}
                  placement="left"
                  type="custom"
                />
                <FormattedText
                  className="broker-hire-alternative-investment-header__product-value"
                  value={`brokerAlternativeFundsBuy-refund_${refund}`}
                />
              </div>

              <div className="broker-hire-alternative-investment-header__quote">
                <FormattedText value={'brokerAlternativeFundsBuy-lockUp'} />
                <OKTooltip
                  content={'brokerAlternativeFundsBuy-lockUp_tooltipContent'}
                  modifier="dark-bg"
                  offset={[-15, 0]}
                  placement="left"
                  type="custom"
                />
                <span className="broker-hire-alternative-investment-header__product-value">
                  {lockUp}
                </span>
                {lockUp > 1 ? (
                  <FormattedText
                    className="broker-hire-alternative-investment-header__product-value"
                    value={'brokerAlternativeFundsBuy-permanencyPeriodYears'}
                  />
                ) : (
                  <FormattedText
                    className="broker-hire-alternative-investment-header__product-value"
                    value={'brokerAlternativeFundsBuy-permanencyPeriodYear'}
                  />
                )}
              </div>

              <div className="broker-hire-alternative-investment-header__quote">
                <FormattedText value={'brokerAlternativeFundsBuy-rentability'} />
                <OKTooltip
                  content={'brokerAlternativeFundsBuy-rentability_tooltipContent'}
                  modifier="dark-bg"
                  offset={[0, 0]}
                  placement="left"
                  type="custom"
                />
                <span className="broker-hire-alternative-investment-header__product-value">
                  {rentability}
                </span>
              </div>
            </div>
          </div>
        </div>
      </ContentBox>
    );
  }
}

BrokerHireAlternativeInvestmentFundHeader.propTypes = {
  immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
  immInvestmentFunds: PropTypes.object.isRequired,
  modifier: PropTypes.string,
};

module.exports = BrokerHireAlternativeInvestmentFundHeader;
